/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { createSelector } from '@ngrx/store';
import { selectInstanceState } from './feature.selector';

export const selectPageInfo = (instanceId: string) => createSelector(selectInstanceState(instanceId), (state) => state?.pageInfo);
